import IconButton from 'LuxKit/Button/IconButton'
import TextButton from 'LuxKit/Button/TextButton'
import React from 'react'

interface Props {
  className?: string
  icon: React.ReactNode
  isIconOnly?: boolean
  label: string
  onClick?: (event?: React.MouseEvent) => void
}

function ShareButton(props: Props) {
  const {
    className,
    icon,
    isIconOnly,
    label,
    onClick,
  } = props
  return <>
    {isIconOnly && <IconButton
      kind="tertiary"
      variant="ghost"
      aria-label={label}
      className={className}
      onClick={onClick}
    >{icon}
    </IconButton>}
    {!isIconOnly && <TextButton
      kind="tertiary"
      variant="ghost"
      className={className}
      onClick={onClick}
    >
      {label}
    </TextButton>}
  </>
}

export default ShareButton
